export function routes($stateProvider) {
    $stateProvider
        .state('app.obler.oi', {
        url: '/oi',
        abstract: true,
        template: '<ui-view></ui-view>'
    })
        .state('app.obler.oi.list', {
        role: ['oblerVerProcessos'],
        url: '?{page:int}&{limit:int}&sortBy&filter',
        template: '<obler-oi-list></obler-oi-list>',
        title: 'Listagem de Ordens de Intervenção',
        params: {
            page: {
                value: 1,
                dynamic: true
            },
            limit: {
                value: 20,
                dynamic: true
            },
            sortBy: {
                array: true,
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.obler.oi.details', {
        url: '/:id',
        role: ['oblerVerProcessos'],
        template: '<obler-oi-details></obler-oi-details>',
        title: 'Visualizar Ordem de Intervenção'
    })
        .state('app.obler.processos', {
        url: '/processos',
        abstract: true,
        template: '<ui-view></ui-view>'
    })
        .state('app.obler.processos.list', {
        role: ['oblerVerProcessos'],
        url: '?{page:int}&{limit:int}&sortBy&filter',
        template: '<obler-processos-list></obler-processos-list>',
        title: 'Listagem de Processos',
        params: {
            page: {
                value: 1,
                dynamic: true
            },
            limit: {
                value: 20,
                dynamic: true
            },
            sortBy: {
                array: true,
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.obler.processos.details', {
        url: '/:id',
        role: ['oblerVerProcessos'],
        template: '<obler-processos-details></obler-processos-details>',
        title: 'Visualizar processo'
    })
        .state('app.obler.processos.add', {
        url: '/novo',
        role: ['oblerVerProcessos'],
        template: '<obler-processos-create></obler-processos-create>',
        title: 'Adicionar processo'
    })
        .state('app.obler.processos.agendar', {
        role: ['oblerVerProcessos'],
        url: '/agendar?{page:int}&{limit:int}&sortBy&filter',
        template: '<obler-processos-agendar></obler-processos-agendar>',
        title: 'Orçamentos a agendar',
        params: {
            page: {
                value: 1,
                dynamic: true
            },
            limit: {
                value: 20,
                dynamic: true
            },
            sortBy: {
                array: true,
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.obler.orders', {
        url: '/encomendas',
        abstract: true,
        template: '<ui-view></ui-view>'
    })
        .state('app.obler.orders.list', {
        role: ['oblerVerProcessos'],
        url: '?{page:int}&{limit:int}&sortBy&filter',
        template: '<obler-encomendas-list></obler-encomendas-list>',
        title: 'Listagem de Encomendas',
        params: {
            page: {
                value: 1,
                dynamic: true
            },
            limit: {
                value: 20,
                dynamic: true
            },
            sortBy: {
                array: true,
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.obler.orders.pending', {
        role: ['oblerVerProcessos'],
        url: '/pendentes?{page:int}&{limit:int}&sortBy&filter',
        template: '<obler-encomendas-pending></obler-encomendas-pending>',
        title: 'Listagem de Encomendas Pendentes',
        params: {
            page: {
                value: 1,
                dynamic: true
            },
            limit: {
                value: 20,
                dynamic: true
            },
            sortBy: {
                array: true,
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.obler.interacoes', {
        url: '/interacoes',
        abstract: true,
        template: '<ui-view></ui-view>'
    })
        .state('app.obler.interacoes.orcamentos', {
        role: ['oblerVerProcessos'],
        url: '/orcamentos?{page:int}&{limit:int}&sortBy&filter',
        template: '<obler-orcamentos-list></obler-processos-list>',
        title: 'Listagem de Orçamentos',
        params: {
            page: {
                value: 1,
                dynamic: true
            },
            limit: {
                value: 20,
                dynamic: true
            },
            sortBy: {
                array: true,
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    })
        .state('app.obler.interacoes.visitas', {
        role: ['oblerVerProcessos'],
        url: '/visitas?{page:int}&{limit:int}&sortBy&filter',
        template: '<obler-visitas-list></obler-processos-list>',
        title: 'Listagem de Visitas Técnicas',
        params: {
            page: {
                value: 1,
                dynamic: true
            },
            limit: {
                value: 20,
                dynamic: true
            },
            sortBy: {
                array: true,
                dynamic: true
            },
            filter: {
                dynamic: true
            }
        }
    });
}
routes.$inject = ['$stateProvider'];
